import { render } from "./MenuHeaderMultiBtn.vue?vue&type=template&id=6ccf97c0"
import script from "./MenuHeaderMultiBtn.vue?vue&type=script&lang=js"
export * from "./MenuHeaderMultiBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__